<template>
  <content-wrapper>
    <Content class="pt-3">
      <b-row>
        <b-col md="3">
          <b-row>
            <b-col>
              <b-form-group
                  id="gate"
                  label="Gate"
                  label-for="gate"
              >
                <b-form-select
                    id="gate"
                    v-model="gate"
                    :options="gates"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                  id="delay"
                  label="Delay"
                  label-for="delay"
              >
                <div class="d-flex justify-content-between flex-wrap">
                  <b-form-select
                      class="w-50"
                      id="delay"
                      v-model="delayInSecond"
                      :options="delays"
                      @change="restartPolling"
                  ></b-form-select>
                  <b-button @click="togglePolling" :variant="usePolling ? 'success' : 'danger'">
                    <i class="fa spinner-border spinner-border-sm" v-if="usePolling"></i>
                    <i class="bi bi-stopwatch" v-else></i>
                  </b-button>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-progress :value="currentProgress" height="4px" :max="delayInSecond * 1000" variant="success"
                      class="mb-3"></b-progress>
          <b-form-group
              id="gate_time"
              label="Gate Time"
              label-for="gate_time"
          >
            <b-form-input
                id="gate_time"
                v-model="eventMeta.time"
                type="text"
                :disabled="true"
                :readonly="true"
            ></b-form-input>
          </b-form-group>
          <b-form-group
              id="License"
              label="License Plate"
              label-for="license"
          >
            <b-form-input
                id="license"
                v-model="$v.formData.lic_plate.$model"
                type="text"
                :state="validateState('formData','lic_plate')"
            ></b-form-input>
            <b-form-invalid-feedback>
              This field is required and its max length is 15 characters
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group
              label="Container"
              label-for="best"
          >
            <b-input-group>
              <b-form-input
                  id="best"
                  v-model.trim="$v.container.$model"
                  type="text"
                  maxLength="15"
                  :disabled="addingToContainer || formData.containers.length===2"
                  :state="validateState('container')"
              ></b-form-input>
              <b-input-group-append>
                <b-button variant="primary"
                          :disabled="addingToContainer || formData.containers.length === 2"
                          @click="addContainerToList"
                >
                  <i class="fa fa-plus" v-if="!addingToContainer"></i>
                  <i class="fa fa-refresh spinner-border spinner-border-sm" v-else></i>
                </b-button>
              </b-input-group-append>
              <b-form-invalid-feedback>
                This field is required and its max length is 15 characters
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
          <b-form-group
              label="Description"
              label-for="desc"
          >
            <b-form-input
                id="desc"
                v-model="formData.desc"
                type="text"
            ></b-form-input>
          </b-form-group>
          <b-table
              ref="containers"
              id="containers"
              :items="formData.containers"
              :fields="containerFields"
              striped
              borderless
              outlined
              hover
              show-empty
              empty-text="Empty container list..."
              stacked
              class="mb-3"
          >
            <template #cell(action)="data">
              <b-button variant="primary"
                        size="sm"
                        class="mr-3"
                        @click="findContainer(data.item.container)"
              >
                <i class="fa fa-receipt"></i>
              </b-button>
              <b-button variant="danger"
                        size="sm"
                        @click="formData.containers.splice(data.index,1)"
              >
                <i class="fa fa-trash"></i>
              </b-button>
            </template>
          </b-table>
          <b-row>
            <b-col class="mb-3">
              <b-button variant="primary"
                        :disabled="isApproving"
                        class="btn-block"
                        @click="approve">
                Approve!
                <b-spinner v-if="isApproving" small></b-spinner>
              </b-button>
            </b-col>
          </b-row>
          <b-link target="_blank" :href="eventMeta.cams.driver">
            <h4 class="text-center"><i class="bi bi-camera-reels-fill"></i> Driver Camera</h4>
          </b-link>
          <b-link target="_blank" class="scroll-hidden" :href="eventMeta.images.driver">
            <!-- <b-img v-bind="image" :src="eventMeta.images.driver"/> -->
            <iframe class="w-100 mb-2" height="225" src="https://cctv.betaserver.my.id/stream.php?id=5" allowfullscreen></iframe>
          </b-link>
        </b-col>
        <!--   Right Panel For showing all cameras     -->
        <b-col md="9">
          <!-- Front & Rear Camera -->
          <b-row class="mb-3">
            <b-col md="6" class="pr-md-2 mb-3 mb-md-0">
              <b-card class="text-center h-100">
                <b-link target="_blank" :href="eventMeta.cams.front">
                  <h4><i class="bi bi-camera-reels-fill"></i> Front Camera</h4>
                </b-link>
                <b-link target="_blank" class="scroll-hidden" :href="eventMeta.images.front">
                  <iframe class="w-100" height="315" src="https://cctv.betaserver.my.id/stream.php?id=1" allowfullscreen></iframe>
                </b-link>
              </b-card>
            </b-col>
        
            <b-col md="6" class="pl-md-2">
              <b-card class="text-center h-100">
                <b-link target="_blank" :href="eventMeta.cams.back">
                  <h4><i class="bi bi-camera-reels-fill"></i> Rear Camera</h4>
                </b-link>
                <b-link target="_blank" :href="eventMeta.images.back">
                  <iframe class="w-100" height="315" src="https://cctv.betaserver.my.id/stream.php?id=2" allowfullscreen></iframe>
                </b-link>
              </b-card>
            </b-col>
          </b-row>
        
          <!-- Left & Right Camera -->
          <b-row class="mb-3">
            <b-col md="6" class="pr-md-2 mb-3 mb-md-0">
              <b-card class="text-center h-100">
                <b-link target="_blank" :href="eventMeta.cams.left">
                  <h4><i class="bi bi-camera-reels-fill"></i> Left Camera</h4>
                </b-link>
                <b-link target="_blank" :href="eventMeta.images.left">
                  <iframe class="w-100" height="315" src="https://cctv.betaserver.my.id/stream.php?id=4" allowfullscreen></iframe>
                </b-link>
              </b-card>
            </b-col>
        
            <b-col md="6" class="pl-md-2">
              <b-card class="text-center h-100">
                <b-link target="_blank" :href="eventMeta.cams.right">
                  <h4><i class="bi bi-camera-reels-fill"></i> Right Camera</h4>
                </b-link>
                <b-link target="_blank" :href="eventMeta.images.right">
                  <iframe class="w-100" height="315" src="https://cctv.betaserver.my.id/stream.php?id=3" allowfullscreen></iframe>
                </b-link>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </Content>
    <!-- SPPB Document Modal   -->
    <b-modal header-bg-variant="secondary" id="sppb" size="lg" title="SPPB Documents">
      <h4>Documents of {{ container }}</h4>
      <b-table :items="documents" v-if="!containerIsLoading"
               :fields="containerColumns"
               responsive
               striped
               borderless
               outlined
               hover
               stacked="sm">
      </b-table>
      <b-skeleton-wrapper :loading="!containerIsLoading">
        <b-skeleton-table
            :rows="5"
            :columns="containerColumns.length"
            :hideHeader="false"
            :table-props="{ bordered: false, striped: true, outlined: true, hover:true, fields: containerColumns, stacked:'sm' }"
        ></b-skeleton-table>
      </b-skeleton-wrapper>
      <template #modal-footer="{ ok, cancel, }">
        <b-button variant="primary" @click="cancel()">
          Close
        </b-button>
      </template>
    </b-modal>
  </content-wrapper>
</template>

<script>
import noImage from "@/assets/img/no-image.png";
import {validationMixin} from "vuelidate";
import {formValidation} from "@/mixins/formValidation";
import {userInfoMixin} from "@/mixins/userInfoMixin";
import {maxLength, required} from "vuelidate/lib/validators";
import {BImg, BLink, BProgress, BSkeletonWrapper, BSkeletonTable, } from "bootstrap-vue";
import {findContainerLocal} from "@/services/bsims";
import Str from "@/helpers/Str";
import {hasOwnProperty} from "@/helpers/Utils";
import {approvePass, listPassEvent} from "@/services/events";

export default {
  name: "EventV2",
  components: {
    BImg,
    BLink,
    // CountDown,
    BProgress,
    BSkeletonWrapper, BSkeletonTable,
  },
  mixins: [
    validationMixin, formValidation, userInfoMixin,
  ],
  validations: {
    container: {
      required,
      maxLength: maxLength(15),
    },
    formData: {
      lic_plate: {
        required,
        maxLength: maxLength(15),
      },
    }
  },
  data: () => ({
    gate: 'in01',
    fetched: false,
    container: null,
    currentProgress: 0,
    image: {
      center: true,
      fluidGrow: true,
      width: 300,
      height: 300,
      class: 'mb-3'
    },
    gates: [
      "in01", "in02","out01","out02",
    ],
    delayInSecond: 5,
    delays: [1, 2, 5, 10, 30],
    formData: {
      event_id: '', // ok
      lane: "", // ok
      direction: 0, // optional
      lic_plate: "", // wajib
      container: "", // wajib
      doc_id: '', // optional
      sppb_no: "", // optional
      sppb_date: "", // optional
      aprv_id: 12, // optional
      aprv_name: "Hasan Sadikin", // optional
      desc: "", // optional
      containers: [],
    },
    eventMeta: {
      time: '',
      images: {
        driver: noImage,
        front: noImage,
        back: noImage,
        left: noImage,
        right: noImage,
      },
      cams: {
        driver: noImage,
        front: noImage,
        back: noImage,
        left: noImage,
        right: noImage,
      },
    },
    defaultMeta: {
      time: '',
      images: {
        driver: noImage,
        front: noImage,
        back: noImage,
        left: noImage,
        right: noImage,
      },
      cams: {
        driver: noImage,
        front: noImage,
        back: noImage,
        left: noImage,
        right: noImage,
      },
    },
    addingToContainer: false,
    containerFields: [
      {
        key: 'container',
        label: 'Container',
      },
      {
        key: 'action',
        label: 'Action',
      },
    ],
    containerIsLoading: false,
    documents: [],
    containerColumns: [
      {
        key: 'sppb_date',
        label: 'Date',
        formatter: x => x.replace(/\+.*/, '')
      },
      {
        key: 'sppb_no',
        label: 'SPPB',
      },
      {
        key: 'consignee',
        label: 'Consignee',
      },
      {
        key: 'actions',
        label: 'Actions',
      }
    ],
    usePolling: false,
    isApproving: false,
    pollingTimer: null,
    progressTimer: null,
  }),
  methods: {
    async addContainerToList() {
      this.$v.container.$touch();
      if (this.$v.container.$anyError) {
        this.$bvToast.toast(`Missing required information!`, {
          title: 'Error!',
          autoHideDelay: 1500,
          appendToast: false,
          variant: 'danger',
        })
        return;
      }
      this.addingToContainer = true;
      const exists = this.formData.containers.filter(({container}) => container === this.container)
      if (exists.length > 0) {
        this.$bvToast.toast(`Container ${this.container} already in the list!`, {
          title: 'Duplication Error!',
          autoHideDelay: 1500,
          appendToast: false,
          variant: 'danger',
        })
        this.addingToContainer = false;
        return;
      }
      try {
        await findContainerLocal({
          container: this.container,
          direction: this.formData.direction,
        });
        this.formData.containers.push({container: Str.removeAllWhitespaces(this.container)})
        this.container = null;
        this.$nextTick(() => {
          this.$v.container.$reset();
        });
        this.addingToContainer = false;
      } catch (e) {
        this.addingToContainer = false;
        if (!hasOwnProperty(e, 'response')) {
          this.$bvToast.toast(`${e.message}`, {
            title: 'Error!',
            autoHideDelay: 1500,
            appendToast: false,
            variant: 'danger',
          })
          return;
        }
      }

    },
    async findContainer(cont) {
      if (!cont) {
        this.$bvToast.toast(`Missing Container information`, {
          title: 'Error!',
          autoHideDelay: 1500,
          appendToast: false,
          variant: 'danger',
        })
        return;
      }
      this.containerIsLoading = true;
      this.container = cont;
      this.$bvModal.show('sppb');
      try {
        const {data: {data: {container}}} = await findContainerLocal({
          container: cont,
          direction: this.formData.direction,
        });
        this.documents = Array.isArray(container.docs) ? container.docs : [container.docs];
      } catch (e) {
        this.documents = [];
      }
      this.containerIsLoading = false;
    },
    togglePolling() {
      this.usePolling = !this.usePolling;
      if (!this.usePolling) {
        return this.clearPolling();
      }
      return this.startPolling();
    },
    clearPolling() {
      this.pollingTimer && clearInterval(this.pollingTimer);
      this.progressTimer && clearInterval(this.progressTimer);
      this.pollingTimer = null;
      this.progressTimer = null;
      this.currentProgress = 0;
    },
    startPolling() {
      if (this.pollingTimer) return;
      this.progressTimer = setInterval(() => {
        if (this.currentProgress === (this.delayInSecond * 1000)) {
          this.currentProgress = 0
        }
        this.currentProgress += 100
      }, 100)
      this.pollingTimer = setInterval(async () => await this.fetchGateEvent(), this.delayInSecond * 1000)
    },
    restartPolling() {
      this.clearPolling();
      this.$nextTick(() => {
        this.startPolling();
      });
      this.usePolling = true;
    },
    async fetchGateEvent() {
      this.clearForm();
      this.formData.containers = [];
      try {
        const {data: {data: {rows}}} = await listPassEvent({
          lane: this.gate,
          status: 0,
        });
        const items = Array.isArray(rows.event) ? rows.event : [rows.event];
        if (!items) {
          this.clearForm();
          return;
        }
        this.clearPolling();
        this.usePolling = false;
        const event = items.find(e => e.lane.toString() === this.gate.toString())
        this.formData.lane = this.gate;
        this.formData.lic_plate = event?.ocr?.lic_plate;
        this.formData.event_id = event.id;
        this.formData.direction = event.direction;
        this.eventMeta.time = event.time;
        this.eventMeta.images = event.image !== null ? event.image : this.defaultMeta.images;
        this.eventMeta.cams = event.livecam !== null ? event.livecam : this.defaultMeta.cams;
      } catch (e) {
        this.clearForm();
        this.eventMeta.time = 'EVENT NOT AVAILABLE';
        console.error(e)
      }
    },
    async approve() {
      if (this.formData.containers.length === 0) {
        this.$v.container.$touch();
      }
      this.$v.formData.$touch();
      if (this.$v.formData.$anyError) {
        this.$bvToast.toast(`Missing required information!`, {
          title: 'Error!',
          autoHideDelay: 1500,
          variant: 'danger',
        })
        return;
      }
      this.isApproving = true;
      try {
        const data = {...this.formData};
        data.containers = data.containers.map(({container}) => container);
        delete data['container'];
        data.aprv_id = this.loggedInUser.id;
        data.aprv_name = this.loggedInUser.username

        await approvePass(data);
        this.$bvToast.toast(`Vehicle [${this.formData.lic_plate}] approved! `, {
          title: 'Approved!',
          autoHideDelay: 1500,
          appendToast: false,
          variant: 'success',
        })
        this.isApproving = false
        this.clearForm();
        this.restartPolling();
      } catch (e) {
        if (!hasOwnProperty(e, 'response')) {
          this.$bvToast.toast(`${e.message}`, {
            title: 'Error!',
            autoHideDelay: 1500,
            variant: 'danger',
          })
          return;
        }
      }
    },
    clearForm() {
      this.$nextTick(() => {
        this.$v.$reset();
      });
      this.container = null;
      this.formData = {
        event_id: '', // ok
        lane: "", // ok
        direction: 0, // optional
        lic_plate: "", // wajib
        container: "", // wajib
        doc_id: '', // optional
        sppb_no: "", // optional
        sppb_date: "", // optional
        aprv_id: 12, // optional
        aprv_name: "Hasan Sadikin", // optional
        desc: "", // optional
        containers: [],
      };
    },
  },
  beforeDestroy() {
    this.clearPolling()
  },
  mounted() {
    this.restartPolling();
  }
}
</script>

<style scoped>
  .scroll-hidden {
    overflow: scroll; /* tetap bisa scroll manual */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE & Edge lama */
  }

  .scroll-hidden::-webkit-scrollbar {
    display: none; /* Chrome, Safari */
  }
</style>
